import LabRepository from "./LabRepository";

const resource = "/analyte-result";

export default {
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  },
  getSampleResults({ connections, filter }) {
    return LabRepository.get(`${resource}?${connections}&${filter}`);
  },
  get(id, params) {
    return LabRepository.get(`${resource}/${id}`, { params });
  },
  create(payload) {
    return LabRepository.post(resource, payload);
  },
  batchUpdate(payload) {
    return LabRepository.put(`${resource}/batch`, payload);
  },
  update(analyte_result_id, payload) {
    return LabRepository.put(`${resource}/${analyte_result_id}`, payload);
  },
  suspend(analyte_result_id) {
    return LabRepository.delete(`${resource}/${analyte_result_id}`);
  },
  deleteBatch(payload) {
    return LabRepository.delete(resource, { data: { id: payload } });
  }
};
